"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.UserAndTeamSearch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var search_overlay_1 = require("../overlay/search-overlay");
exports.UserAndTeamSearch = react_1["default"].memo(function UserAndTeamSearch(props) {
    return ((0, jsx_runtime_1.jsx)(search_overlay_1.SearchOverlay, { onClose: props.onClose, filterType: ["person", "organization/team"], overridePlaceholderText: "Type to start searching...", overrideFocusLabel: "Search for people or teams", onSelectResult: function (r) {
            return props.onSelectResult(r);
        } }));
});
